import { render, staticRenderFns } from "./FixCase.vue?vue&type=template&id=73c5273d"
import script from "./FixCase.vue?vue&type=script&lang=js"
export * from "./FixCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports